import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';
import { extendConfiguration } from './config';

import * as Sentry from '@sentry/browser';

extendConfiguration().then(() => {
  if (environment.production) {
    enableProdMode();
  }

  if (environment.sentry) {
    Sentry.init({
      dsn: environment.sentry || undefined,
      environment: environment.envName || undefined,
      release: environment.version,
    });
  }

  import('./app/app.module').then((m) => {
    platformBrowser()
      .bootstrapModule(m.AppModule)
      .catch((err) => console.log(err));
  });
});
